import axios from 'axios';

export const fetchClientReport = async (data) => {
  const response = await axios.post('/api/client-report', data);

  return response.data;
};
